import { Row, Col, Input, Form, Select } from 'antd';
import { ssFormUtils, ssFormValidationUtils, ssCommonUtils } from '@bit/ui-common.ui-components/ss-utils';
import { dodOfficeAddressConfig } from './formConfig';

const
config = dodOfficeAddressConfig,
{ key } = config,
{ generateFormItem, generateInputComponent,generateCountryOptionsFromCommonData,generateStateOptionsFromCommonData } = ssFormUtils,
{ validateForm, validateSubForm } = ssFormValidationUtils;

export default class DodOfficeAddress extends React.Component {
    constructor(props) { super(props); }

    componentDidUpdate(prevProps) {
        const
        { services, registrationForm } = this.props,
        currForm = registrationForm[key],
        prevForm = prevProps.registrationForm[key],
        { storeForm } = services;

        if(!ssCommonUtils.simpleObjectCompare(prevForm, currForm)) {
            const formState = validateForm(currForm, config, true);
            storeForm(key, formState);
            this.setState({ isValid: validateSubForm(formState) });
        }
    }

    render() {
        const
        span = 6,
        { services, registrationForm, geo } = this.props,
        { storeFormField, storeForm } = services,
        form = registrationForm[key];

        return (
            <div>
                <Row type='flex' justify='center'>
                    <Col span={23}>
                        <Row type='flex' justify='center' gutter={12}>
                            <Col span={span}>
                                <Form.Item {...generateFormItem('embassy', config, form)}>
                                    <Select {...{...generateInputComponent('embassy', config, true, form, storeFormField, storeForm), style: { width: '100%' }}}>
                                      {generateCountryOptionsFromCommonData(geo.geoDataStore)}
                                    </Select>
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row type='flex' justify='center' gutter={12}>
                            <Col span={span}>
                                <Form.Item {...generateFormItem('streetAddress', config, form)}>
                                    <Input {...{...generateInputComponent('streetAddress', config, true, form, storeFormField, storeForm), style: { width: '100%' }}} />
                                </Form.Item>
                            </Col>
                            <Col span={span}>
                                <Form.Item {...generateFormItem('city', config, form)}>
                                    <Input {...{...generateInputComponent('city', config, true, form, storeFormField, storeForm), style: { width: '100%' }}} />
                                </Form.Item>
                            </Col>
                            <Col span={span}>
                                <Form.Item {...generateFormItem('country', config, form)}>
                                    <Select {...{...generateInputComponent('country', config, true, form, storeFormField, storeForm), style: { width: '100%' }}}>
                                      {generateCountryOptionsFromCommonData(geo.geoDataStore)}
                                    </Select>
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row type='flex' justify='center' gutter={12}>
                            <Col span={span}>
                                <Form.Item {...generateFormItem('stateProvince', config, form)}>
                                    <Select {...{...generateInputComponent('stateProvince', config, true, form, storeFormField, storeForm), style: { width: '100%' }}}>
                                        {generateStateOptionsFromCommonData(geo.geoDataStore, form.country || null)}
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={span}>
                                <Form.Item {...generateFormItem('zipPostal', config, form)}>
                                    <Input {...{...generateInputComponent('zipPostal', config, true, form, storeFormField, storeForm), style: { width: '100%' }}} />
                                </Form.Item>
                            </Col>
                            <Col span={span}>
                                <Form.Item {...generateFormItem('phoneNumber', config, form)}>
                                    <Input {...{...generateInputComponent('phoneNumber', config, true, form, storeFormField, storeForm), style: { width: '100%' }}} />
                                </Form.Item>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </div>
        );
    }
}
